import { View } from 'react-native'
import { Skeleton } from '@/components/ui/Skeleton'
import { RADIUS, SPACING } from '@/lib/brand'

type TourCardSkeletonLayout = 'compact' | 'tile'

/**
 * Skeleton de una tarjeta de tour. Tile = portada 3:2 con el título encima
 * (misma silueta que la tarjeta editorial). Compact = lista de teléfono.
 */
export function TourCardSkeleton({
  staggerIndex = 0,
  layout = 'compact',
}: {
  staggerIndex?: number
  layout?: TourCardSkeletonLayout
}) {
  const isTile = layout === 'tile'
  return (
    <View>
      {isTile ? (
        <View style={{ width: '100%', aspectRatio: 3 / 2 }}>
          <Skeleton
            width="100%"
            height="100%"
            borderRadius={RADIUS.lg}
            staggerIndex={staggerIndex}
          />
        </View>
      ) : (
        <Skeleton width="100%" height={140} borderRadius={RADIUS.lg} staggerIndex={staggerIndex} />
      )}
      {isTile ? null : (
        <View style={{ paddingTop: SPACING.sm + 2, paddingHorizontal: 2, gap: SPACING.xs }}>
          <Skeleton width="65%" height={18} staggerIndex={staggerIndex} />
          <Skeleton width="90%" height={14} staggerIndex={staggerIndex} />
          <Skeleton width="45%" height={13} staggerIndex={staggerIndex} />
        </View>
      )}
    </View>
  )
}
